const COUNTRY_PREFIXES = {
  rs: '381',
  ba: '387',
  hr: '385',
  me: '382',
  mk: '389',
  si: '386'
};

const safeText = (v) => (typeof v === 'string' ? v.trim() : '');

export const digitsOnly = (v) => safeText(v).replace(/\D/g, '');

export const aiPhonesMismatch = (a, b) => {
  const x = digitsOnly(a);
  const y = digitsOnly(b);
  if (!x || !y) return false;
  return x !== y;
};

export const isLikelyWrongAiPhone = (phone, countryCode = 'rs') => {
  if (!phone) return false;
  const cc = (countryCode || 'rs').toLowerCase();
  if (cc === 'rs' || cc === 'sr' || cc === 'serbia') {
    if (/^\+39[16]\d{8,11}$/.test(phone)) return true;
  }
  return false;
};

export const isPhoneStructurallyValid = (phone) => {
  if (!phone) return false;
  const digits = digitsOnly(phone);
  return digits.length >= 9 && digits.length <= 13;
};

export const normalizePhoneForSave = (input, countryCode = 'rs') => {
  const raw = safeText(input);
  if (!raw) return '';

  const cleaned = raw.replace(/[^\d+]/g, '');
  const compact = cleaned.startsWith('+')
    ? `+${cleaned.slice(1).replace(/\+/g, '')}`
    : cleaned.replace(/\+/g, '');

  if (!compact) return '';

  if (compact.startsWith('00')) {
    return `+${compact.slice(2)}`;
  }

  const cc = (countryCode || 'rs').toLowerCase();
  const ccDigits = COUNTRY_PREFIXES[cc];

  if (compact.startsWith('+')) {
    const digits = compact.slice(1);
    if (digits.length >= 9 && digits.length <= 13) {
      return compact;
    }
    return '';
  }

  if (compact.startsWith('0') && ccDigits) {
    return `+${ccDigits}${compact.slice(1)}`;
  }

  if (ccDigits && compact.startsWith(ccDigits) && compact.length >= ccDigits.length + 8) {
    return `+${compact}`;
  }

  if (ccDigits && compact.length === 9 && compact.startsWith('6')) {
    return `+${ccDigits}${compact}`;
  }

  return compact;
};

export const isValidMobileForCountry = (phone, countryCode = 'rs') => {
  if (!isPhoneStructurallyValid(phone)) return false;
  const cc = (countryCode || 'rs').toLowerCase();
  const digits = digitsOnly(phone);

  if (cc === 'rs' || cc === 'sr' || cc === 'serbia') {
    if (digits.startsWith('381')) {
      return digits.startsWith('3816') || digits.startsWith('3817');
    }
    if (digits.startsWith('0')) {
      return /^0[6-9]/.test(digits);
    }
    if (digits.length === 9) {
      return digits.startsWith('6');
    }
    return false;
  }

  return true;
};

export const getPhoneValidationIssues = (phone, countryCode = 'rs', opts = {}) => {
  const { primaryAI, verifierAI } = opts;
  const issues = [];

  if (!phone) {
    if (primaryAI || verifierAI) {
      issues.push({ code: 'ai_mismatch', message: 'AI nije uspeo da potvrdi broj — proverite ručno.' });
    }
    return issues;
  }

  if (!isPhoneStructurallyValid(phone)) {
    issues.push({ code: 'invalid_length', message: 'Broj nema ispravan broj cifara (9–13).' });
  }

  if (isLikelyWrongAiPhone(phone, countryCode)) {
    issues.push({ code: 'wrong_prefix', message: 'Sumnjiv prefiks (+39 umesto +381) — verovatno AI greška.' });
  }

  if (!isValidMobileForCountry(phone, countryCode)) {
    issues.push({ code: 'not_mobile', message: 'Broj nije prepoznat kao mobilni za vašu zemlju.' });
  }

  if (primaryAI && verifierAI && aiPhonesMismatch(primaryAI, verifierAI)) {
    issues.push({
      code: 'ai_digit_mismatch',
      message: `AI čita dva različita broja: "${primaryAI}" vs "${verifierAI}" — proverite cifru po cifru.`
    });
  }

  return issues;
};

export const phoneNeedsManualReview = (phone, countryCode = 'rs', opts = {}) =>
  getPhoneValidationIssues(phone, countryCode, opts).length > 0;
